import { c as _c } from "react-compiler-runtime";
import { memo } from 'react';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Spacer } from 'foundations-components/components/Spacer';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { HeaderLeftBorder } from './HeaderLeftBorder';
import { ResizeAffordance, ResizeAffordanceSpace } from './ResizeAffordance';
import { ContextMenuHeaderTriggerButton, useFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shared component for column headers with and without DnD.
 * It lays out the column header to compensate the space when DnD'ing a column.
 */
function ContentComponentInner(t0) {
  const $ = _c(59);
  const {
    arrowsNode,
    children,
    columnName,
    columnNamespace,
    draggedLeft,
    draggedRight,
    isDragging,
    onClick,
    onMouseDown,
    resizable,
    reorderable,
    hasNewTableHeader,
    sortDirection
  } = t0;
  const contextMenuConfig = useFDTContextMenuConfig();
  let t1;
  if ($[0] !== columnName || $[1] !== columnNamespace || $[2] !== contextMenuConfig) {
    t1 = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.getIsContextMenuOpen({
      row: null,
      columnName,
      columnNamespace
    });
    $[0] = columnName;
    $[1] = columnNamespace;
    $[2] = contextMenuConfig;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isContextMenuOpen = t1;
  const dragAndDropStatus = resizable ? "dnd" : "no-dnd";
  const dataTestId = `content-component-${dragAndDropStatus}-${columnName}`;
  if (hasNewTableHeader) {
    const t2 = reorderable && !isDragging && draggedLeft;
    let t3;
    if ($[4] !== t2) {
      t3 = /*#__PURE__*/_jsx(Box, {
        flexShrink: 0,
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(HeaderLeftBorder, {
          $shouldHighlight: t2
        })
      });
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const t4 = !sortDirection;
    let t5;
    if ($[6] !== arrowsNode || $[7] !== t4) {
      t5 = /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "100",
        paddingInline: "200",
        "data-hide-when-not-hovered": t4,
        children: arrowsNode
      });
      $[6] = arrowsNode;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== children || $[10] !== t5) {
      t6 = /*#__PURE__*/_jsx(Box, {
        flexGrow: 1,
        paddingInlineStart: "300",
        overflow: "auto",
        children: /*#__PURE__*/_jsx(TruncateString, {
          useFlex: true,
          alignItems: "center",
          fixedChildren: t5,
          children: children
        })
      });
      $[9] = children;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const t7 = !isContextMenuOpen;
    let t8;
    if ($[12] !== columnName || $[13] !== columnNamespace || $[14] !== hasNewTableHeader) {
      t8 = /*#__PURE__*/_jsx(ContextMenuHeaderTriggerButton, {
        columnNamespace: columnNamespace,
        columnName: columnName,
        hasNewTableHeader: hasNewTableHeader
      });
      $[12] = columnName;
      $[13] = columnNamespace;
      $[14] = hasNewTableHeader;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t7 || $[17] !== t8) {
      t9 = /*#__PURE__*/_jsx(Box, {
        flexShrink: 0,
        "data-hide-when-not-hovered": t7,
        children: t8
      });
      $[16] = t7;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== columnName || $[20] !== columnNamespace || $[21] !== draggedRight || $[22] !== isDragging || $[23] !== onClick || $[24] !== onMouseDown || $[25] !== reorderable || $[26] !== resizable) {
      t10 = /*#__PURE__*/_jsx(Box, {
        blockSize: "100%",
        flexShrink: 0,
        children: resizable ? /*#__PURE__*/_jsx(ResizeAffordance, {
          "data-test-id": `resize-header-${columnNamespace}-${columnName}`,
          onClick: onClick,
          onMouseDown: onMouseDown,
          $shouldHighlight: reorderable && !isDragging && draggedRight
        }) : /*#__PURE__*/_jsx(ResizeAffordanceSpace, {
          $shouldHighlight: reorderable && !isDragging && draggedRight
        })
      });
      $[19] = columnName;
      $[20] = columnNamespace;
      $[21] = draggedRight;
      $[22] = isDragging;
      $[23] = onClick;
      $[24] = onMouseDown;
      $[25] = reorderable;
      $[26] = resizable;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] !== dataTestId || $[29] !== t10 || $[30] !== t3 || $[31] !== t6 || $[32] !== t9) {
      t11 = /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "100%",
        "data-test-id": dataTestId,
        inlineSize: "100%",
        children: [t3, t6, t9, t10]
      });
      $[28] = dataTestId;
      $[29] = t10;
      $[30] = t3;
      $[31] = t6;
      $[32] = t9;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    return t11;
  }
  const t2 = reorderable && !isDragging && draggedLeft;
  let t3;
  if ($[34] !== t2) {
    t3 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(HeaderLeftBorder, {
        $shouldHighlight: t2
      })
    });
    $[34] = t2;
    $[35] = t3;
  } else {
    t3 = $[35];
  }
  let t4;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: "300"
      })
    });
    $[36] = t4;
  } else {
    t4 = $[36];
  }
  let t5;
  if ($[37] !== children) {
    t5 = /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: children
      })
    });
    $[37] = children;
    $[38] = t5;
  } else {
    t5 = $[38];
  }
  let t6;
  if ($[39] !== arrowsNode) {
    t6 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "100",
        paddingInline: "200",
        children: arrowsNode
      })
    });
    $[39] = arrowsNode;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  let t7;
  if ($[41] !== columnName || $[42] !== columnNamespace) {
    t7 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(ContextMenuHeaderTriggerButton, {
        columnNamespace: columnNamespace,
        columnName: columnName
      })
    });
    $[41] = columnName;
    $[42] = columnNamespace;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] !== columnName || $[45] !== columnNamespace || $[46] !== draggedRight || $[47] !== isDragging || $[48] !== onClick || $[49] !== onMouseDown || $[50] !== resizable) {
    t8 = /*#__PURE__*/_jsx(Box, {
      blockSize: "100%",
      flexShrink: 0,
      children: resizable ? /*#__PURE__*/_jsx(ResizeAffordance, {
        "data-test-id": `resize-header-${columnNamespace}-${columnName}`,
        onClick: onClick,
        onMouseDown: onMouseDown,
        $shouldHighlight: !isDragging && draggedRight
      }) : /*#__PURE__*/_jsx(ResizeAffordanceSpace, {})
    });
    $[44] = columnName;
    $[45] = columnNamespace;
    $[46] = draggedRight;
    $[47] = isDragging;
    $[48] = onClick;
    $[49] = onMouseDown;
    $[50] = resizable;
    $[51] = t8;
  } else {
    t8 = $[51];
  }
  let t9;
  if ($[52] !== dataTestId || $[53] !== t3 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: "100%",
      "data-test-id": dataTestId,
      inlineSize: "100%",
      children: [t3, t4, t5, t6, t7, t8]
    });
    $[52] = dataTestId;
    $[53] = t3;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
  } else {
    t9 = $[58];
  }
  return t9;
}
export default /*#__PURE__*/memo(ContentComponentInner);